/**
 * /secretariat/enseignants — Équipe pédagogique, spécialités, couleurs planning.
 * Réutilise BoSecretariatEnseignantsPage.
 */
import React from 'react';
import BoSecretariatEnseignantsPage from '../bo/BoSecretariatEnseignantsPage';

export default function SecretariatEnseignantsPage() {
  return <BoSecretariatEnseignantsPage embedded />;
}
